export const iconFontAwesomeCodingCodeFork = (
	<i className="fa-solid fa-code-fork"></i>
);
